import React, { useState, useEffect } from 'react';
import prettyBytes from 'pretty-bytes';
import ResponseTabGroup from '../../Tab-Groups/ResponseTabGroup';

export default function Response({ response, loading, setResponse }) {
  const [doc, setDoc] = useState('{}');

  useEffect(() => {
    if (response === null) return;
    const jsonResponse = JSON.stringify(response.data, null, 2);
    setDoc(jsonResponse);
  }, [response, loading]);

  const hasResponse = !(response == null);

  let time = '';
  let status = '';
  let size = '';

  if (hasResponse) {
    const hasCustomData = 'customData' in response;
    const hasData = 'data' in response;
    const hasHeaders = 'headers' in response;

    status = hasResponse ? response.status : 0;

    if (hasData && hasHeaders) {
      size = prettyBytes(
        (hasResponse ? JSON.stringify(response.data).length : 0) +
          (hasResponse ? JSON.stringify(response.headers).length : 0)
      );
    }

    if (hasCustomData) {
      time = response.customData.time + 'ms';
    }
  }

  const getStatusColor = (status) => {
    if (status >= 200 && status < 300) return 'text-green-600';
    if (status >= 300 && status < 400) return 'text-blue-600';
    if (status >= 400 && status < 500) return 'text-orange-600';
    if (status >= 500) return 'text-red-600';
    return 'text-gray-600';
  };

  const handleClear = () => {
    setDoc('{}'); // Reset response body to empty JSON
    setResponse(null); // Clear response to remove headers and meta
  };

  const RenderedResponseMeta = () => {
    return (
      <div className="flex items-center mt-2 gap-4">
        <span className={`text-sm font-semibold ${getStatusColor(status)}`}>Status: {status}</span>
        <span className="text-sm text-gray-600">Time: {time}</span>
        <span className="text-sm text-gray-600">Size: {size}</span>
        <button
          className="ml-auto p-2 rounded-lg text-[#fdb814] border-2 border-[#fdb814] hover:bg-gradient-to-r hover:from-[#fdb814] hover:to-[#e5a50f] hover:text-white transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-4 focus:ring-[#fdb814]/30"
          onClick={handleClear}
          title="Clear Response"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1-1H9a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button>
      </div>
    );
  };

  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      {response && (
        <div className="flex items-center justify-between mb-4 flex-shrink-0">
          <div className="flex items-center gap-3">
            <span className={`px-3 py-1 text-xs font-bold rounded-full border-2 ${getStatusColor(status)}`}>
              {status}
            </span>
            <div className="flex items-center gap-1 text-xs text-gray-500">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              {time}
            </div>
            <div className="flex items-center gap-1 text-xs text-gray-500">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4" />
              </svg>
              {size}
            </div>
          </div>
          <button
            className="p-1.5 rounded-lg text-gray-400 hover:text-red-600 hover:bg-red-50 transition-all duration-200"
            onClick={handleClear}
            title="Clear Response"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      )}
      
      {/* Content */}
      <div className="flex-1 min-h-0">
        <ResponseTabGroup
          doc={doc}
          setDoc={setDoc}
          response={response}
          setResponse={setResponse}
          loading={loading}
        />
      </div>
    </div>
  );
}